import axios from "axios";
import React, { useEffect, useState } from "react";
import { API } from "../../Api";
import { Link } from "react-router-dom";
import java from "../../Assets/project/Java.jpg"
import python from "../../Assets/project/python.jpeg"
import net from "../../Assets/project/net.jpg"
import mern from "../../Assets/project/mern.jpg"
import mini from "../../Assets/project/mini.jpeg"
import php from "../../Assets/project/php.jpg"


export default function ProjectHome() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${API}/api/projects`);
        setProjects(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProjects();
  }, []);

  const categories = [
    { name: "Python", img: python },
    { name: "Java", img: java },
    { name: ".NET", img: net},
    { name: "MERN", img: mern },
    { name: "Mini", img: mini },
    { name: "PHP", img: php }
  ];

  const defaultContent = {
    Python: {
      title: "Python Projects",
      description:
        "From AI to automation, our Python projects showcase creativity and intelligence."
    },
    Java: {
      title: "Java Projects",
      description:
        "Robust, scalable, and dynamic – Java projects for enterprise & web apps."
    },
    ".NET": {
      title: ".NET Projects",
      description:
        "Experience the power of Microsoft technologies with .NET applications."
    },
    MERN: {
      title: "MERN Projects",
      description:
        "Full-stack development with React, Node.js, MongoDB, and Express."
    },
    Mini: {
      title: "Mini Projects",
      description:
        "Quick, creative, and clever – perfect for experimentation & prototypes."
    },
    PHP: {
      title: "PHP Projects",
      description:
        "Dynamic web applications with PHP. Learn, explore, and build!"
    }
  };

  return (
    <div>
    <div className="pr-banner">
  <div className="pr-banner-overlay">
    <h1 className="pr-banner-title">Our Projects</h1>
    <p className="pr-banner-subtitle">
      Explore projects in Python, MERN, Java, .NET, PHP, and Mini categories 🚀
    </p>
  </div>
</div>

    <div className="pr-container pr-fade-in">

      {
      categories.map((cat) => {
        const filteredProjects = projects.filter(
          (p) => p.technology.toLowerCase() === cat.name.toLowerCase()
        );

        return (
          <div key={cat.name} className="pr-card ">
            <img
              src={cat.img}
              alt={`${cat.name} banner`}
              className="pr-card-img"
            />
            <div className="pr-card-body">
              <h3 className="pr-card-title">{defaultContent[cat.name].title}</h3>
              <p className="pr-card-desc">{defaultContent[cat.name].description}</p>

              {filteredProjects.length > 0 ? (
                <ul className="pr-project-list">
                  {filteredProjects.slice(0, 5).map((proj) => (
                    <li key={proj._id} className="pr-project-item">
                      <Link to={`/project/details/${proj._id}`}>
                        {proj.projectTitle}
                      </Link>
                      <span className="pr-badge">{proj.projectCode}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="pr-no-project">No {cat.name} projects yet.</p>
              )}

              {filteredProjects.length > 5 && (
                <Link
                  to={`/projects/${cat.name.toLowerCase()}`}
                  className="pr-btn"
                >
                  View All {cat.name} Projects
                </Link>
              )}
            </div>
          </div>
        );
      })}
    </div>
    </div>
  );
}
